// *******************************************************************************
// 1.0 - Open Inquiry Modal
// *******************************************************************************

attachEvent('.detail__inquiry-modal-trigger', 'click', (ev) => {
  const inquiryModal = document.querySelector('.inquiry-modal');

  if (inquiryModal) {
    inquiryModal.classList.add('is-open-modal');
    toggleBodyScrollLock(true);
    ev.preventDefault();
  }
});
